import React from 'react'
import { Flex, Text } from '@pancakeswap/uikit'
import QuestionHelper from 'components/QuestionHelper'
import { useTranslation } from 'contexts/Localization'

const GasSettings = () => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="column">
      <Flex mb="12px" alignItems="center">
        <Text>{t('Gas Settings')}</Text>
        <QuestionHelper
          text={t(
            'Gas fees are automatically estimated by your wallet (MetaMask) based on the network conditions.',
          )}
          placement="top-start"
          ml="4px"
        />
      </Flex>
      <Flex>
        <Text fontSize="14px" color="textSubtle">
          {t('No manual gas selection is needed — transactions will always use the correct network fee.')}
        </Text>
      </Flex>
    </Flex>
  )
}

export default GasSettings
